module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.25.0@babel-runtime/core-js/is-iterable.js
// module id = 118
// module chunks = 1